// src/components/ReviewsForm/ReviewsForm.styled.js
import styled from 'styled-components';
import { TextField, Box, Button, Typography } from '@mui/material';

export const Wrapper = styled(Box)`
  padding: 24px 20px 12px;
  background: linear-gradient(135deg, #f0faff 0%, #e3f2fd 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

export const Heading = styled(Typography).attrs({
  variant: 'h4',
  component: 'h2',
})`
  font-weight: 800;
  color: #0d4efe;
  margin-bottom: 6px;
  text-align: center;
`;

export const Subheading = styled(Typography).attrs({
  variant: 'subtitle1',
})`
  color: #444;
  text-align: center;
  margin-bottom: 18px;
  max-width: 700px;
`;

export const FormContainer = styled(Box)`
  background-color: #ffffff;
  padding: 28px;
  border-radius: 24px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  max-width: 900px;
  width: 100%;
  margin: 12px auto 24px;
`;

export const StyledTextField = styled(TextField)`
  & .MuiOutlinedInput-root {
    border-radius: 12px;
  }

  & label.Mui-focused {
    color: #0d4efe;
  }

  & .MuiOutlinedInput-root.Mui-focused fieldset {
    border-color: #01ebb2;
  }
`;

export const RatingRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const RatingLabel = styled.div`
  font-weight: 700;
  color: #0d4efe;
  font-size: 1.05rem;
`;

export const SubmitButton = styled(Button)`
  margin-top: 18px;
  width: 100%;
  max-width: 420px;
  padding: 12px 0;
  font-size: 1.05rem;
  font-weight: 700;
  background: linear-gradient(90deg, #01ebb2, #0d4efe);
  color: white;
  border-radius: 999px;
  text-transform: none;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(13, 78, 254, 0.25);
    background: linear-gradient(90deg, #0d4efe, #01ebb2);
  }
`;
